@if (isOffline) {
  <div>
    <div class="img-placeholder">
      <img src="../../../../assets/img/placeholder.svg" />
    </div>
    <ebs-offline-message [isOffline]='isOffline' [offlineMessage]='offlineMessage'></ebs-offline-message>
  </div>
}


@if (gettingFileIFrameActivity) {
  <ebs-spinner [spinnerMessage]="'loading..'" [faColour]="'#999'" [boxColour]="'#999'"
  [boxPadding]="'5px 15px'"></ebs-spinner>
}
@if (!gettingFileIFrameActivity && !isOffline) {
  <div class="card-body">
    <div class="row">
      <div class="col-sm-12 hidden-print">
        <iframe class="embed-responsive-item embed-responsive-16by9 ebs-media-response" title="articulate media iframe"
        [src]="activityItem.sourceUrl | domSanitizerPipe: 'resourceUrl'" allowfullscreen=""></iframe>
      </div>
      <div style="display: none;" class="col-sm-12 d-none d-print-block img-placeholder">
        <img src="../../../../assets/img/placeholder.svg" />
      </div>
    </div>
  </div>
}